<template>
  <div class="relative reveal-on-hover" @mouseover="init">
    <div class="hidden absolute pin-b mb-8 p-2 bg-grey-light center-x with-tooltip rounded z-20 pointer-events-none">
      <div class="popup-inner overflow-y-scroll bg-grey-dark">
        <loader v-if="loading" fillColor="white" class="my-6" />
        <div v-else class="text-left p-2 text-white">
          <div class="flex flex-row items-center flex-1 h-full border-white border-bottom p-2">
            <div class="flex flex-col w-1/2 text-left px-2">
              <p class="mb-2 md:text-sm uppercase text-lg">{{ property.address}}, {{property.postcode}}</p>
              <span>Dates the property has appeared in the data: </span>
            </div>

            <div class="flex flex-col w-1/4 text-center border-r border-white px-2">
              <p class="mb-2 md:text-sm uppercase">Appeared</p>
              <p class="text-3xl">{{ appearedCounts }}</p>
            </div>

            <div class="flex flex-col w-1/4 text-center px-2 text-green-light">
              <p class="mb-2 text-xs md:text-sm uppercase">Mailed To</p>
              <p class="text-3xl">{{ mailedCounts }}</p>
            </div>
          </div>
          <div>
            <div class="py-4 w-1/4 border-bottom border-grey items-center float-left" :class="flag?'text-green-light':''" v-for="(flag, date) in dates" :key="date">
              {{ date }} <span v-if="flag" class="pl-2 absolute"><svg width="20px" fill="#54D38C" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M46.58838,39.65925H1.41162a.5.5,0,1,1,0-1H46.58838a.5.5,0,0,1,0,1Z"/><path d="M45.72584,26.57236a.58032.58032,0,0,0-.01645-.07c-.00311-.0087-.00273-.01788-.00627-.02654a.61745.61745,0,0,0-.10283-.16789l-.00077-.00138L30.32224,8.54955l-.01315-.01023a.6134.6134,0,0,0-.16435-.13211l-.01-.00354c-.0133-.00684-.02765-.00875-.04128-.01454a.61194.61194,0,0,0-.16707-.04577.59961.59961,0,0,0-.06759-.00259.60773.60773,0,0,0-.15229.01794.58563.58563,0,0,0-.06395.01688.61123.61123,0,0,0-.19333.10848L2.46743,31.69788a.61041.61041,0,0,0-.136.17487.59827.59827,0,0,0-.02641.061.58736.58736,0,0,0-.02755.38742c.00369.01421.00345.02851.00814.04253l.002.01052a.61362.61362,0,0,0,.10614.18233l.00813.01444,4.61044,5.35875H8.64571L4.25457,32.82587l16.9217.48237-1.01851,4.62149h1.268l1.01057-4.58557,4.48435.12786a.61872.61872,0,0,0,.63218-.54389l.543-4.45312,15.22252-1.02257L31.23561,37.84789l-.09513.08184H33.039L45.534,27.17961a.61181.61181,0,0,0,.13733-.17659.58676.58676,0,0,0,.0264-.06423.60678.60678,0,0,0,.03936-.14388.59687.59687,0,0,0,.00617-.075A.60788.60788,0,0,0,45.72584,26.57236Zm-19.33369,5.646L4.48674,31.594,29.045,10.46522Zm1.85635-4.99471,2.0492-16.80413,13.55577,15.756Z"/></svg></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span>
      <span v-if="property.last_contacted">{{ property.last_contacted }}</span>
      <span v-else>-</span>
    </span>
  </div>
</template>

<script>
import api from '@/http'
export default {
  props: ['property', 'officeId'],
  data () {
    return {
      dates: {
      },
      requested: false,
      loading: true,
      appearedCounts: 0,
      mailedCounts: 0
    }
  },
  methods: {
    init: function () {
      if (this.requested) {
        return
      }
      this.requested = true

      return api.get('/aps/manage-data/order-history', {
        params: {
          udprn: this.property.udprn,
          office_id: this.officeId
        }
      }).then(response => {
        this.dates = response.data.dates
        this.appearedCounts = response.data.total
        this.mailedCounts = response.data.mailed
        this.loading = false
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.popup-inner
  width: 720px
  height: auto
  max-height: 300px

.reveal-on-hover:hover > div
  display: block

.with-tooltip
    &::after, &::before
      content: ''
      width: 0
      height: 0

      position: absolute

      left: 50%
      bottom: -8px
      transform: translateX(-50%)

      border-right: 8px solid transparent
      border-left: 8px solid transparent

      border-top: 8px solid #DAE1E7
</style>
